/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InstrumentSensorDto } from '../models/InstrumentSensorDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SensorService {

  /**
   * @returns InstrumentSensorDto OK
   * @throws ApiError
   */
  public static getSensors(): CancelablePromise<Array<InstrumentSensorDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/sensor',
    });
  }

}
